"use client";
import { useEffect } from "react";

/**
 * Component that marks the hydration of the application by setting a data attribute on the HTML element.
 * This is used to signal to UI tests that the application has been hydrated and interaction events may begin.
 * @returns null
 */
export const HydrationMarker = () => {
    useEffect(() => {
        document.documentElement.dataset.hydrated = "true";
    }, []);
    return null;
};
